var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMarketplaceBag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#333",
  clipPath: "url(#marketplace-bag_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13 3.629H2v11h11zM10.634 3.292v.336h-.91v-.336c0-1.314-1.019-2.38-2.276-2.38-1.258 0-2.276 1.066-2.276 2.38v.336h-.91v-.336C4.262 1.477 5.692 0 7.45 0s3.189 1.475 3.189 3.292z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 3.629H2v11h11zM10.634 3.292v.336h-.91v-.336c0-1.314-1.019-2.38-2.276-2.38-1.258 0-2.276 1.066-2.276 2.38v.336h-.91v-.336C4.262 1.477 5.692 0 7.45 0s3.189 1.475 3.189 3.292z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 3.629H2v11h11zM10.634 3.292v.336h-.91v-.336c0-1.314-1.019-2.38-2.276-2.38-1.258 0-2.276 1.066-2.276 2.38v.336h-.91v-.336C4.262 1.477 5.692 0 7.45 0s3.189 1.475 3.189 3.292z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "marketplace-bag_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h15v14.628H0z"
})))));
export default SvgMarketplaceBag;